module.exports = __webpack_public_path__ + "img/icon-battery.de845cd4.svg";